import {
  SET_BUYER_FORM_DATA,
  REMOVE_BUYER_FORM_DATA
} from '../constants/AppConstants';

const initialState = {
  buyerFormData: {},
};

export default (state = initialState, action) => {
  
  switch (action.type) {
    case SET_BUYER_FORM_DATA: {
      const buyerFormData = action.payload;
      console.log(state);
      return {
        ...state,
        buyerFormData
      }
    }
    case REMOVE_BUYER_FORM_DATA: {
      return state;
    }
    default: {
      return state;
    }
  }
};
